export const APP_NAME = 'dynamic_content_pages_perseus';
export const API_POLLING_INTERVAL_SEC = 300;
